import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

export const useScrollPosition = () => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const updatePosition = debounce(
            () => {
                setScrollPosition(window.pageYOffset);
            },
            150,
            {
                leading: true
            }
        );

        window.addEventListener("scroll", updatePosition);

        updatePosition();

        return () => window.removeEventListener("scroll", updatePosition);
    }, []);

    return scrollPosition;
};
